var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotesEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1914 130.314L77.5004 119.25V73.8887L42.1914 84.8674V130.314Z",
    fill: "#D5DAE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.809 130.314L77.5 119.25V73.8887L112.809 84.8674V130.314Z",
    fill: "#F1F3FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M112.809 130.314L77.5 119.25V73.8887L112.809 84.8674V130.314Z",
    fill: "#AAB2C5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1914 130.314L77.5004 119.25V73.8887L42.1914 84.8674V130.314Z",
    fill: "url(#paint0_linear_6726_12394)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.809 130.314L77.5004 119.25V73.8887L112.809 84.8674V130.314Z",
    fill: "url(#paint1_linear_6726_12394)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5004 141.463L42.1914 130.399V85.0371L77.5004 96.1009V141.463Z",
    fill: "#F1F3FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 141.463L112.809 130.399V85.0371L77.5 96.1009V141.463Z",
    fill: "#D5DAE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M69.5004 133.463L42.1914 130.399V85.0371L77.5004 96.1009L69.5004 133.463Z",
    fill: "url(#paint2_linear_6726_12394)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.5 125.463L112.809 130.399V85.0371L77.5 96.1009L85.5 125.463Z",
    fill: "url(#paint3_linear_6726_12394)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 73.8884L60.8989 61.4629L25 73.548L42.191 84.8671L77.5 73.8884Z",
    fill: "#D5DAE5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5 73.8884L94.1011 61.4629L130 73.548L112.809 84.8671L77.5 73.8884Z",
    fill: "#D5DAE5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M42.191 85.0371L77.5 96.1009L59.8876 107.335L25 95.7605L42.191 85.0371Z",
    fill: "#F1F3FA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M112.809 85.0371L77.5 96.1009L95.1124 107.335L130 95.7605L112.809 85.0371Z",
    fill: "#F1F3FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3515 30.3394C92.2981 43.7639 93.7725 46.7467 94.2564 59.9746C94.0703 62.9941 93.9549 66.2775 92.5313 68.9213C90.6302 72.9658 85.9802 75.7668 81.5869 75.8121C77.0609 75.893 72.6238 73.1219 70.6267 68.8488C69.2216 66.2555 69.2663 62.7082 71.1937 60.3536C73.289 58.0955 76.9752 57.5324 79.6269 58.9434C82.5438 60.2834 84.2848 63.0695 84.9297 66.0079C85.5745 68.9462 85.2912 72.1332 84.504 75.0308C82.8578 82.0783 81.4943 82.4192 77.457 94.351",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3709 23.235C93.3595 25.2089 91.5225 26.4176 89.1929 25.7873C86.7402 25.3692 85.0042 24.9383 84.8925 23.1765C84.9488 21.3697 86.9201 20.6626 89.2274 19.8654C91.994 18.7661 93.2144 21.306 93.3709 23.235Z",
    fill: "#D5DAE5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5221 29.2699C78.7652 30.5495 81.3859 30.9226 82.663 28.968C84.0633 26.8012 85.262 25.226 83.9742 23.7792C82.7311 22.4995 81.5214 23.3611 78.7548 24.4604C76.5371 25.5919 76.0663 27.868 77.5221 29.2699Z",
    fill: "#D5DAE5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2593 21.1048C84.3905 20.6226 85.7457 20.9763 86.3504 21.8894C86.6079 22.1788 86.9103 22.6353 86.9998 22.9697C87.9627 25.2202 87.66 27.4514 86.3607 27.9785C84.9382 28.7179 82.9784 27.4511 82.2283 25.3227C82.0492 24.654 81.9596 24.3196 81.8253 23.8181C81.6798 22.6028 82.128 21.5869 83.2593 21.1048C83.4273 21.0598 83.2593 21.1048 83.2593 21.1048Z",
    fill: "#AAB2C5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2573 58.3025C31.2573 57.7668 30.823 57.3326 30.2874 57.3326H30.0672C29.5149 57.3326 29.0672 56.8849 29.0672 56.3326V56.0812C29.0672 55.5628 28.647 55.1426 28.1286 55.1426C27.6103 55.1426 27.19 55.5628 27.19 56.0812V56.3326C27.19 56.8849 26.7423 57.3326 26.19 57.3326H25.9699C25.4342 57.3326 25 57.7668 25 58.3025C25 58.8381 25.4342 59.2724 25.9699 59.2724H26.19C26.7423 59.2724 27.19 59.7201 27.19 60.2724V60.5238C27.19 61.0422 27.6103 61.4624 28.1286 61.4624C28.647 61.4624 29.0672 61.0422 29.0672 60.5238V60.2724C29.0672 59.7201 29.5149 59.2724 30.0672 59.2724H30.2874C30.823 59.2724 31.2573 58.8381 31.2573 58.3025Z",
    fill: "url(#paint4_linear_6726_12394)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9921 113.944C36.1109 113.422 35.7839 112.902 35.2616 112.783L35.0469 112.734C34.5084 112.612 34.1711 112.076 34.2937 111.537L34.3494 111.292C34.4644 110.787 34.1479 110.284 33.6425 110.169C33.137 110.054 32.634 110.37 32.519 110.876L32.4633 111.121C32.3407 111.659 31.8048 111.997 31.2663 111.874L31.0516 111.825C30.5293 111.706 30.0096 112.033 29.8908 112.556C29.7719 113.078 30.099 113.598 30.6213 113.717L30.836 113.766C31.3745 113.888 31.7117 114.424 31.5892 114.962L31.5334 115.208C31.4184 115.713 31.735 116.216 32.2404 116.331C32.7459 116.446 33.2488 116.13 33.3638 115.624L33.4196 115.379C33.5421 114.84 34.078 114.503 34.6166 114.626L34.8312 114.675C35.3535 114.793 35.8733 114.466 35.9921 113.944Z",
    fill: "url(#paint5_linear_6726_12394)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M131.354 113.297C131.603 112.804 131.405 112.202 130.912 111.954L130.018 111.502C129.525 111.253 129.327 110.652 129.576 110.159L130.028 109.265C130.276 108.772 130.079 108.17 129.586 107.921L129.074 107.663C128.581 107.414 127.98 107.612 127.731 108.105L127.279 108.999C127.03 109.492 126.429 109.69 125.936 109.441L125.042 108.99C124.549 108.741 123.947 108.939 123.698 109.432L123.402 110.02C123.153 110.513 123.351 111.114 123.844 111.363L124.738 111.814C125.231 112.063 125.429 112.665 125.18 113.158L124.728 114.052C124.479 114.545 124.677 115.146 125.17 115.395L125.682 115.654C126.175 115.902 126.776 115.705 127.025 115.212L127.476 114.317C127.725 113.824 128.327 113.626 128.82 113.875L129.714 114.327C130.207 114.576 130.808 114.378 131.057 113.885L131.354 113.297Z",
    fill: "url(#paint6_linear_6726_12394)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6726_12394",
    x1: 66.3541,
    y1: 77.174,
    x2: 61.5381,
    y2: 97.2238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6726_12394",
    x1: 66.3541,
    y1: 77.174,
    x2: 61.5381,
    y2: 97.2238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6726_12394",
    x1: 50.1075,
    y1: 116.082,
    x2: 58.5901,
    y2: 92.1243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#6C80AA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D6A86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6726_12394",
    x1: 96.5558,
    y1: 122.627,
    x2: 97.2229,
    y2: 92.2243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#314F91",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#324264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6726_12394",
    x1: 28.1291,
    y1: 55.3621,
    x2: 28.1291,
    y2: 58.9094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6726_12394",
    x1: 33.5942,
    y1: 110.383,
    x2: 32.8073,
    y2: 113.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6726_12394",
    x1: 129.195,
    y1: 108.061,
    x2: 127.004,
    y2: 112.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesEmpty);
export default __webpack_public_path__ + "static/media/notesEmpty.7d86e58990071f6a26f1dadff07f5131.svg";
export { ForwardRef as ReactComponent };